import React from 'react'
import * as styles from './CallToActionButton.module.scss'
import OutlineButton from './OutlineButton/OutlineButton'
// import { Icon } from '@iconify/react';

const CallToActionButton = ({ buttonData, type }) => {
  return (
    <div className={`${styles.calltoAction_btn_wrap} ${styles[`${type}`]}`}>
      <div className={`hexagon ${type === 'colored' ? 'red' : 'white'}`}>
        <div className="hexTop"></div>
        <div className="hexBottom"></div>
      </div>
      <div className={`${styles.calltoAction_trim} `}></div>
      <OutlineButton type={type} buttonData={buttonData} />
    </div>
  )
}

export default CallToActionButton
